import type { Vertical } from 'shared/search/common/config';
import { CarrentalSeo } from './CarrentalSeo';
import { FhhSeo } from './FhhSeo';
import { FlightSeo } from './FlightSeo';
import { HotelSeo } from './HotelSeo';
import { PrepackageSeo } from './PrepackageSeo';

type FrontpageSeoProps = {
    vertical: Vertical;
};

export const FrontpageSeo = ({ vertical }: FrontpageSeoProps) => {
    switch (vertical) {
        case 'flight':
            return <FlightSeo />;
        case 'hotel':
            return <HotelSeo />;
        case 'carrental':
            return <CarrentalSeo />;
        case 'prepackage':
            return <PrepackageSeo />;
        case 'fhh':
            return <FhhSeo />;
        default:
            return <FlightSeo />;
    }
};
